<template>
  <div class="document-finder">
    <div>
      <div
        class="mbm"
        v-html="jobs.description"
      />
      <v-client-table
        :id="titleId"
        :ref="titleId"
        :name="titleId"
        :data="jobs"
        :columns="columns"
        :options="options"
      >
        <a
          :id="row.id"
          slot="class_code"
          slot-scope="{row}"
          target="_blank"
          :href="'https://www.phila.gov/departments/office-of-human-resources/job-specs/'+row.class_code+'.htm'"
        ><span>{{ row.class_code }}</span></a>
        <div slot="afterFilter">
          <span><i class="fas fa-search fa-2x" /></span>
        </div>
        <div
          slot="beforeTable"
          class="table-info"
          :class="{ hide: !viewMessage}"
        >
          <span><i class="fas fa-info-circle fa-3x" /></span>
          <span class="table-message"><p>These are the results out of a total {{ jobs.length }} records for the search of <strong>{{ searchTerm }}</strong>. Please click the clear filter button to view all records.</p></span>
          <span class="table-button"><button @click="closeMessage"><a>Clear filter</a></button></span>
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>
window.daterangepicker = require('daterangepicker');


export default {
  name: 'ResidencyWaiver',
  props: {
    jobs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    query: {
      type: String,
      default: () => {
        return null;
      },
    },
  },
  data: function() {
    return {
      columns: [ 
        'waiver_number',
        'class_code',
        'class_title',
        'date_signed',
        'terms',
      ],
      options: {
        addSortedClassToCells: true,
        dateColumns: [ 'date_signed' ],
        toMomentFormat: 'MMMM D, YYYY',
        dateFormat: 'MMMM D, YYYY',
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down',
        },
        texts: {
          filterPlaceholder: "Search by",
        },
        perPage: 10,
        perPageValues: [],
        pagination: {
          chunk : 3,
        },
        customFilters: [{
          name: 'dropdownFilter',
          callback: function (row, query) {
            return row.Category == query;
          },
        }],
      },
      titleId: 'jobs-table',
      categoryList: [ 'test' ],
      viewMessage: false,
      searchTerm: null,
    };
  },
  mounted () {
    let vm = this;
    vm.init();
  },
  methods: {
    async init () {
      let vm = this;
      await vm.searchQuery();
    },
    async searchQuery () {
      let vm = this;
      if(vm.$route.query.q ) {
        vm.searchTerm = vm.$route.query.q;
        vm.$refs[vm.titleId].setFilter(vm.searchTerm);
      }
    },
    closeMessage () {
      let vm  = this;
      vm.viewMessage = false;
      vm.$refs[vm.titleId].resetQuery();
    },
    showMessage () {
      let vm  = this;
      vm.viewMessage = true;
    },
  },
};
</script>